import React from 'react';
import { createUseStyles } from 'react-jss';
import styles from './CollectionEmptyModal.styles';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';
import { useHistory } from 'react-router-dom';

const useStyles = createUseStyles(styles, { name: 'CollectionEmptyModal' });

interface CollectionEmptyModalProps {
  className?: string;
  icon?: JSX.Element;
  buttonText: string;
  link: string;
  title: string;
  'data-testid': string;
}

const CollectionEmptyModal = (props: CollectionEmptyModalProps): JSX.Element => {
  const { icon, buttonText, link, title, ...rest } = props;
  const history = useHistory();
  const handleOnClick = () => {
    if (!link) {
      return;
    }
    history.push(link);
  };
  const classes = useStyles();
  return (
    <div className={classes.container} data-testid={rest['data-testid']}>
      <span className={classes.icon}>{icon}</span>
      <span className={classes.title}>{title}</span>
      <Button
        type={ButtonTypes.SECONDARY}
        text={buttonText}
        onClick={handleOnClick}
        data-testid="collection-empty-modal-button"
      />
    </div>
  );
};

export default CollectionEmptyModal;
